import type { VisionProposalSharedContext } from "@/features/analytics/constants/events";
import type { ProposalPayload } from "../types";

/** Non-reactive device read for call sites outside a React render (the SMB
 * provider stays on useMediaQuery so it re-renders across the breakpoint). */
export function currentDevice(): VisionProposalSharedContext["device"] {
  return window.matchMedia("(min-width: 768px)").matches ? "desktop" : "mobile";
}

/**
 * Shared context stamped on every proposal event (Proposta 2.0 taxonomy).
 * Single construction point for the ENT page, the SMB cover track and the
 * SMB provider — `|| null` (not ??) because these come from form-shaped
 * state where "absent" is an empty string, which must never reach Segment.
 */
export function buildProposalSharedContext(
  proposal: ProposalPayload | null,
  device: VisionProposalSharedContext["device"],
): VisionProposalSharedContext {
  const diagnosis = proposal?.state?.diagnosis;
  return {
    proposal_uuid: proposal?.uuid ?? "",
    deal_id: diagnosis?.dealId || null,
    device,
    client_segment: diagnosis?.segment || null,
    proposal_type: proposal?.proposalType ?? null,
  };
}
